import { Injectable } from '@angular/core';

@Injectable()
export class DevelopmentEnvironmentGuard {
  public canLoad(): boolean {
    return DEV_FEATURES_ENABLED;
  }
}
